var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRecord(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#51B3DA"
    },
    d: "M474.542,131.007h-61.298c-11.28,0-20.426-9.145-20.426-20.426V20.426 C392.818,9.145,401.964,0,413.244,0h61.298c11.28,0,20.426,9.145,20.426,20.426v90.156 C494.968,121.861,485.823,131.007,474.542,131.007z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFEDBE"
    },
    d: "M413.245,512H37.458c-11.28,0-20.426-9.145-20.426-20.426V20.426C17.032,9.145,26.177,0,37.458,0 h375.788c11.28,0,20.426,9.145,20.426,20.426v471.149C433.671,502.855,424.526,512,413.245,512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDA79"
    },
    d: "M413.245,0H225.351v512h187.893c11.28,0,20.426-9.145,20.426-20.426V20.426 C433.671,9.145,424.526,0,413.245,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF5E5B"
    },
    d: "M276.381,133.962h-30.604v-30.604c0-11.28-9.145-20.426-20.426-20.426s-20.426,9.145-20.426,20.426 v30.604h-30.604c-11.28,0-20.426,9.145-20.426,20.426c0,11.28,9.145,20.426,20.426,20.426h30.604v30.604 c0,11.28,9.145,20.426,20.426,20.426s20.426-9.145,20.426-20.426v-30.604h30.604c11.28,0,20.426-9.145,20.426-20.426 C296.806,143.107,287.661,133.962,276.381,133.962z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC72D"
    },
    d: "M339.098,309.855H111.604c-11.28,0-20.426-9.145-20.426-20.426s9.145-20.426,20.426-20.426h227.494 c11.28,0,20.426,9.145,20.426,20.426S350.38,309.855,339.098,309.855z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC72D"
    },
    d: "M339.098,372.54H111.604c-11.28,0-20.426-9.145-20.426-20.426s9.145-20.426,20.426-20.426h227.494 c11.28,0,20.426,9.145,20.426,20.426S350.38,372.54,339.098,372.54z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC72D"
    },
    d: "M339.098,435.225H111.604c-11.28,0-20.426-9.145-20.426-20.426s9.145-20.426,20.426-20.426h227.494 c11.28,0,20.426,9.145,20.426,20.426S350.38,435.225,339.098,435.225z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF423D"
    },
    d: "M276.381,133.962h-30.604v-30.604c0-11.28-9.145-20.426-20.426-20.426v142.909 c11.28,0,20.426-9.145,20.426-20.426v-30.604h30.604c11.28,0,20.426-9.145,20.426-20.426 C296.806,143.107,287.661,133.962,276.381,133.962z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB700"
    },
    d: "M339.098,269.004H225.351v40.851h113.747c11.28,0,20.426-9.145,20.426-20.426 S350.38,269.004,339.098,269.004z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB700"
    },
    d: "M339.098,331.689H225.351v40.851h113.747c11.28,0,20.426-9.145,20.426-20.426 C359.523,340.834,350.38,331.689,339.098,331.689z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB700"
    },
    d: "M339.098,394.373H225.351v40.851h113.747c11.28,0,20.426-9.145,20.426-20.426 S350.38,394.373,339.098,394.373z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecord);
export default __webpack_public_path__ + "static/media/record.d65086367be6d711754270174aaf7deb.svg";
export { ForwardRef as ReactComponent };